import { EnvVarManager } from '@/env/envVarManager';

export const isProduction = EnvVarManager.getEnvVar('NEXT_PUBLIC_APP_ENV') === 'production';
